export class AccessOptions {
  all = false;
  delete = false;
  put = false;
  get = false;
  post = false;
}
